<template>
    <landlords-find
        :params="{
            landlord: $route.params.landlord
        }"
        :include="[
            'account'
        ]"
    >
        <div
            slot-scope="{
                data: landlord,
                error,
                is_loading,
                has_loaded,
                find
            }"
            :class="!has_loaded || error ? '' : 'rounded bg-white shadow mb-6'"
        >
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <with-variables
                v-else
                :variables="{ landlord }"
            >
                <div slot-scope="{ landlord: { account } }">
                    <feature-right-image v-if="false && account.status === account.consts.status.pending">
                        <template slot="heading">
                            Verifying...
                        </template>

                        <template slot="text">
                            It usually takes <strong>few minutes</strong> to verify, but it can take <strong>few business days</strong>.
                            If it’s taken longer than 7 days, <span class="text-blue">get in touch</span>.
                        </template>

                        <base-svg
                            slot="image"
                            name="illustration-unauthorized"
                            class="w-full"
                        />
                    </feature-right-image>

                    <feature-right-image v-else-if="account.status === account.consts.status.verified">
                        <template slot="heading">
                            Account verified!
                        </template>

                        <template slot="text">
                            Thanks for verifying your account. You can now invite your tenants and
                            get paid!
                        </template>

                        <router-link
                            slot="footer"
                            :to="{ name: $router.fix('dashboard.*.residencies.create') }"
                            class="w-full btn btn-blue md:w-auto"
                        >
                            New Tenant
                        </router-link>

                        <base-svg
                            slot="image"
                            name="illustration-unauthorized"
                            class="w-full"
                        />
                    </feature-right-image>

                    <template v-else>
                        <header>
                            <div class="flex items-center px-4 py-3 sm:px-6 md:py-3">
                                <div class="flex-grow">
                                    <h1 class="py-2 text-lg font-normal md:py-3">Verify Account</h1>
                                </div>

                                <div class="w-6 h-6 mr-3">
                                    <base-svg
                                        v-show="is_loading"
                                        name="icon-loading"
                                        class="w-full h-full fill-current text-grey"
                                    />
                                </div>

                                <div class="w-6 h-6 mr-3">
                                    <base-svg
                                        name="icon-lock"
                                        class="w-full h-full fill-current text-grey"
                                    />
                                </div>
                            </div>
                            <with-dimensions>
                                <div
                                    slot-scope="{ width }"
                                    class="px-4 py-3 border-t border-b sm:px-6 md:py-3 bg-grey-bg"
                                >
                                    <div
                                        :class="width > 536 ? 'is-expanded' : ''"
                                        class="progress-steps"
                                    >
                                        <component
                                            :is="step > 1 ? 'router-link' : 'span'"
                                            :to="step > 1 ? { name: $router.fix('dashboard.*.verification.intro.edit') } : null"
                                            :class="{
                                                'is-active': step === 1,
                                                'is-highlighted': step >= 1
                                            }"
                                            class="progress-step is-first"
                                        >
                                            <span class="progress-label">Intro</span>
                                        </component>
                                        <component
                                            :is="step > 2 ? 'router-link' : 'span'"
                                            :to="step > 2 ? { name: $router.fix('dashboard.*.verification.account.edit') } : null"
                                            :class="{
                                                'is-active': step === 2,
                                                'is-highlighted': step >= 2
                                            }"
                                            class="progress-step"
                                        >
                                            <span class="progress-label">Account</span>
                                        </component>
                                        <component
                                            :is="step > 3 && account.type === account.consts.type.business ? 'router-link' : 'span'"
                                            :to="step > 3 && account.type === account.consts.type.business ? { name: $router.fix('dashboard.*.verification.business.edit') } : null"
                                            :class="{
                                                'is-active': step === 3,
                                                'is-highlighted': step >= 3,
                                                'line-through': step >= 3 && account.type !== account.consts.type.business
                                            }"
                                            class="progress-step"
                                        >
                                            <span class="progress-label">Business</span>
                                        </component>
                                        <component
                                            :is="step > 4 ? 'router-link' : 'span'"
                                            :to="step > 4 ? { name: $router.fix('dashboard.*.verification.bank.edit') } : null"
                                            :class="{
                                                'is-active': step === 4,
                                                'is-highlighted': step >= 4
                                            }"
                                            class="progress-step"
                                        >
                                            <span class="progress-label">Bank</span>
                                        </component>
                                        <div
                                            :class="{
                                                'is-active': step === 5,
                                                'is-highlighted': step >= 5,
                                            }"
                                            class="progress-step is-last"
                                        >
                                            <span class="progress-label">Confirm</span>
                                        </div>
                                    </div>
                                </div>
                            </with-dimensions>
                        </header>

                        <router-view @success="find" />
                    </template>
                </div>
            </with-variables>
        </div>
    </landlords-find>
</template>

<script>
    import _ from 'lodash'
    import FeatureRightImage from '../../../../components/feature-right-image'
    import LandlordsFind from '../../../../components/landlords-find'

    export default {
        components: {
            FeatureRightImage,
            LandlordsFind
        },
        computed: {
            step () {
                return _.indexOf([
                    this.$router.fix('dashboard.*.verification.intro.edit'),
                    this.$router.fix('dashboard.*.verification.account.edit'),
                    this.$router.fix('dashboard.*.verification.business.edit'),
                    this.$router.fix('dashboard.*.verification.bank.edit'),
                    this.$router.fix('dashboard.*.verification.confirm.edit')
                ], this.$route.name) + 1
            }
        }
    }
</script>
